import React, { useEffect, useState } from "react";
import { TabView, TabPanel } from "primereact/tabview";
import { Button } from "primereact/button";
import AddEditCompanyProfile from "../companyProfileSetup/AddEditCompanyProfile";
import AddEditCompanyProducts from "../companyProducts/AddEditCompanyProducts";
import CompanyProducts from "../companyProducts/CompanyProducts";
import CompanyUsers from "../../company/companyUsers/CompanyUsers";
import AddEditCompanyUsers from "../../company/companyUsers/AddEditCompanyUsers";
import AddEditAuthMatrix from "../../company/authMatrix/AddEditAuthMatrix";
import AddEditAuthMatrixDetails from "../../company/authMatrix/AddEditAuthMatrixDetails";
import AuthMatrix from "../../company/authMatrix/AuthMatrix";
import { handlePostRequest } from "../../../services/PostTemplate";
import "./CompanyDetails.css";
import { useLocation } from "react-router-dom";

function CompanyDetails() {

    const [authMatrixHeadId, setauthMatrixHeadId] = useState("");
    const [squentailStateDisable, setSequentialState] = useState(false);
    const [companyName, setCompanyName] = useState()
    const [editable, setEditable] = useState()

    const [activeIndex, setActiveIndex] = useState(0);

    const companyId = localStorage.getItem("companyIdAdmin");
    // const editable = localStorage.getItem("editable");

    const location = useLocation()

    useEffect(() => {
        const getCompanyName = localStorage.getItem("companyNameAdmin")
        if (location.state || getCompanyName) {
            const companyName = location?.state?.companyName || getCompanyName
            setCompanyName(companyName)
        } if (location.state) {
            const editable = location.state.editable
            setEditable(editable)
        }
    }, [location.state]);


    // useEffect(() => {
    //     if (companyId === undefined || companyId === null || companyId === "") {
    //         history.push("/groupprofile");
    //     }
    // }, []);

    const handleSequential = (value) => {
        setSequentialState(value);
    };

    const handleAddEditAuthMatrix = async (res) => {
        console.log('res handleAddEditAuthMatrix', res)
        setauthMatrixHeadId(res?.data?.authMatrixHeadId);
    };

    const handleAuthorizeCompanyProfile = async () => {
        const data = {
            companyId: companyId,
            mcStatus: "A",
        };
        await handlePostRequest(data, "zbizgateway/nonFin/saveAuthorizeCompanyProfile/");
    };

    return (
        <React.Fragment>
            {localStorage.getItem("authorizeAllowed") === "Y" ? (
                <div className="p-mb-4 Down__Btn">
                    <Button label="Authorize" onClick={handleAuthorizeCompanyProfile} className="Btn__Dark" />
                </div>
            ) : null}
            <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
                <TabPanel header={`${companyName} Profile`}>
                    <AddEditCompanyProfile edit={true} companyId={companyId} editable={editable} />
                </TabPanel>
                <TabPanel header={`${companyName} Products`}>
                    <AddEditCompanyProducts companyId={companyId} editable={editable} />
                    <CompanyProducts companyId={companyId} />
                </TabPanel>
                {/* <TabPanel header="Company Accounts">
                    <AddEditCompanyAccounts companyId={companyId} />
                    <CompanyAccounts companyId={companyId} />
                </TabPanel> */}
                <TabPanel header={`Authorized ${companyName} Users`}>
                    <AddEditCompanyUsers companyId={companyId} editable={editable} />
                    <CompanyUsers companyId={companyId} />
                </TabPanel>
                {/* <TabPanel header="Company Acc & Products">
                    <AddEditCUAP companyId={companyId} />
                    <CompanyUserAccountsProduct companyId={companyId} />
                </TabPanel> */}
                <TabPanel header={`${companyName} Authorization Matrix`}>
                    <AddEditAuthMatrix companyId={companyId} handleAddEditAuthMatrix={handleAddEditAuthMatrix} handleSequential={handleSequential} editable={editable} />
                    <AuthMatrix companyId={companyId} />
                    <AddEditAuthMatrixDetails companyId={companyId} authMatrixHeadId={authMatrixHeadId} squentailStateDisable={squentailStateDisable} editable={editable} />
                </TabPanel>
                {/* <TabPanel header="Link Parser">
                    <AddEditParserLink companyId={companyId} />
                    <ParserHeadLinked companyId={companyId} />
                </TabPanel> */}
            </TabView>
        </React.Fragment>
    );
}

export default CompanyDetails;
